module.exports = __webpack_public_path__ + "img/getBorder@2x.2eeb7bba.png";